export default "__VITE_ASSET__CpeS_WF2__"